import { render, staticRenderFns } from "./HsnTsnList.vue?vue&type=template&id=8dc1797c&scoped=true&"
import script from "./HsnTsnList.vue?vue&type=script&lang=js&"
export * from "./HsnTsnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc1797c",
  null
  
)

export default component.exports